import React from 'react';
import {AiOutlineMail} from "react-icons/ai";
import {BsFillTelephoneFill} from "react-icons/bs";
import {CiLocationArrow1} from "react-icons/ci";
import {
  FaFacebookSquare,
  FaInstagram,
  FaTwitterSquare,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <div id='footer' className='max-w-[1240px] mx-auto py-16 px-4 grid lg:grid-cols-3 gap-8 text-gray-300'>
      <div className='lg:col-span-2'>
        <a href='#navbar'><h1 className='text-3xl font-bold text-[#F08000]'>YEE SHIN THIPAW</h1></a>
        <p className='py-4'>Copyright© 2023 Yee Shin Thipaw. All rights reserved.</p>
        <div className='flex justify-between md:w-[20%] my-6'>
            <a href='https://www.facebook.com/yeeshin.Hsipaw' target='_blank'> <FaFacebookSquare size={30} /> </a>
            <a href='https://instagram.com/yeeshinthipaw?igshid=MzRlODBiNWFlZA==' target='_blank'> <FaInstagram size={30} /> </a>
            <a href='https://mail.google.com/mail/u/0/#inbox?compose=CllgCJfnZvjMPrlPMNTSBXzrQJpcZKXBZpWZZGPmCHQCBMdmpmshlvswhPgdWgvczZjZwTPGMcL' target='_blank'> <AiOutlineMail size={30} /> </a>
        </div>
      </div>
      <div className='lg:col-span-1 mt-6'>
          <div>
            <h6 className='font-medium p-2'>
                  လိုအပ်ချိန်တိုင်းဆက်သွယ်လိုက်ပါ
            </h6>
            <p className="p-2"><AiOutlineMail style={{ display: 'inline-block', verticalAlign: 'middle' }}/> : yeeshinthipaw1@gmail.com</p>
            <p className="p-2"><BsFillTelephoneFill style={{ display: 'inline-block', verticalAlign: 'middle' }}/> : 09455454544, 09957660954</p>
            <a href='https://maps.app.goo.gl/NxeXch7VgAXp43vL8' target="_blank"><p className="p-2"><CiLocationArrow1 style={{ display: 'inline-block', verticalAlign: 'middle' }}/> : မိုင်းပွန်လမ်း၊ အနောက်ရပ်ကွက်၊ သီပေါမြို့</p></a>
            <h6 className='p-2 pt-10 pb-0 font-medium text-gray-600'>Software Developed by Htoo Myat Aung</h6>
          </div>
      </div>
    </div>
  );
};

export default Footer;